import styled from 'styled-components'
import { Stack, Theme } from '@mui/material'

export const TextFieldContainer = styled(Stack)<{
  theme: Theme
  iserror?: boolean
}>`
  border-radius: 10px;
  border: 1px solid
    ${({ theme, iserror }) =>
      iserror ? theme.palette.error.main : theme.palette.secondary.main};

  &:focus-within {
    border: 1px solid
      ${({ theme, iserror }) =>
        iserror ? theme.palette.error.main : theme.palette.primary.main};
  }
`
